export const environment = {
	production: true
};
export interface Environment {
	endPoint: string;
	finoEndPoint: string;
	imageLink: string;
	websiteLink: string;
	tinyUrl: string;
	ctinyUrl: string;
	cosmoswebsite: string;
	igmEndPoint: string;
	mapKey: string;
	siteKey: string;
}

let envObj = {
	endPoint: 'https://common.cosmossurfaces.com/api/',
	finoEndPoint: 'https://uat-backend.cosmossurfaces.com/api/v1/',
	// endPoint:'https://staging.cosmosgranite.com/api/',
	imageLink: 'https://cosmossurfaces.com/',
	websiteLink: 'https://www.finoporcelain.com',
	tinyUrl: 'https://cosmosgranite.nyc3.digitaloceanspaces.com/cosmossurfaces/images',
	ctinyUrl: 'https://cosmosgranite.nyc3.cdn.digitaloceanspaces.com/finowebsite',
	cosmoswebsite: 'https://cosmosgranite.com/assets/maps/',
	igmEndPoint: 'https://app.igmsurfaces.com/api/v1/',
	mapKey: 'AIzaSyCMnUw7FLREKH9UnQfsWocQUfyQiE5MNQo',
	siteKey: '6LdiriEaAAAAALagxF2_Ts8292g_M3fXBV52Hf0v'
}
if ((window.location.href.indexOf('staging.finoporcelain') != -1) || (window.location.href.indexOf('localhost') != -1)) {
	envObj = {
		endPoint: 'https://common.cosmossurfaces.com/api/',
		finoEndPoint: 'https://uat-backend.cosmossurfaces.com/api/v1/',
		// endPoint:'https://staging.cosmosgranite.com/api/',
		imageLink: 'https://staging.cosmosgranite.com/',
		websiteLink: 'https:/  /staging.finoporcelain.com',
		tinyUrl: 'https://cosmosgranite.nyc3.digitaloceanspaces.com/cosmossurfaces/images',
		ctinyUrl: 'https://cosmosgranite.nyc3.cdn.digitaloceanspaces.com/finowebsite',
		cosmoswebsite: 'https://cosmosgranite.com/assets/maps/',
		igmEndPoint: 'https://uat-app.igmsurfaces.com/api/v1/',
		mapKey: 'AIzaSyCECNx6YKAjaYfP9Eq7FXAMB1QmjUKvMZk',
		siteKey: '6LdiriEaAAAAALagxF2_Ts8292g_M3fXBV52Hf0v'
	}
}


export const PROD: Environment = envObj

export const environment1: Environment = PROD;
